import React, {Fragment} from "react";
import axios from "axios";
import {connect} from "react-redux";
import {createUser, loadStatus, logOutUser} from "../actions/postAction";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import LoadingBar from "react-top-loading-bar";
import moment from "moment";
import "moment-timezone";
import "react-datepicker/dist/react-datepicker.css";
import {BASE_URL} from "../constant";
import Loader from "react-loader-spinner";
import {thisExpression} from "@babel/types";
import {Loading} from "./Loading";
import SimpleReactValidator from "simple-react-validator";
import {NetworkError} from "./NetworkError";
import {endpoints, http} from "../configs/https";

class Ishaat extends React.Component {
    constructor() {
        super();
        this.state = {
            truth: 0,
            review: 0,
            irfan: 0,
            websites: 0,
            extra_work: "",
            periodicals: 0,
            news_items: "",
            attachment: null,
            phone: "",
            isSubmitting: false,
            submitted: false,
            loading: true
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onChangeFile = this.onChangeFile.bind(this);
    }

    componentDidMount() {
        document.title = "ISHAAT - MKAN REPORT";
        this.setupValidator();
    }

    setupValidator() {
        this.setState({
            loading: false
        });
        const {year, month} = this.props.monthYear;
        const {failed} = this.props.status;
        if (failed) {
            this.props.loadStatus(month, year);
        }
        this.validator = new SimpleReactValidator();
    }

    onChangeFile(e) {
        this.setState({attachment: e.target.files[0]});
    }

    handleChange(event) {
        const {name, value} = event.target;
        this.setState({
            [name]: value
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        const {month, year, monthName} = this.props.monthYear;
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`
            this.forceUpdate();
            return;
        }

        if (this.state.phone.length > 11) {
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
            });

            Toast.fire({
                type: "warning",
                title: "Nazim's phone number should not be greater than 11 characters"
            });
            return;
        }
        if (this.state.extra_work.length > 200) {
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
            });
            Toast.fire({
                type: "warning",
                title: "Extra work done field should not be more than 200 characters"
            });
            return;
        }
        if (this.state.news_items.length > 200) {
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
            });

            Toast.fire({
                type: "warning",
                title: "News item field should not be more than 200 characters"
            });
            return;
        }

        Swal.fire({
            title:
                "Are you sure you want to submit your Ishaat report for " +
                monthName +
                " " +
                year +
                "?",
            text:
                "You won't be able to revert this after submitting, kindly check all details are accurate.",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Submit",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33"
        }).then(result => {
            if (result.value) {
                this.LoadingBar.staticStart(10);
                this.setState({
                    isSubmitting: true
                });
                const formData = new FormData();
                if (this.state.attachment != null)
                    formData.append("attachment", this.state.attachment);
                formData.append("truth", this.state.truth);
                formData.append("review", this.state.review);

                formData.append("irfan", this.state.irfan);

                formData.append("websites", this.state.websites);
                formData.append("extra_work", this.state.extra_work);

                formData.append("periodicals", this.state.periodicals);
                formData.append("news_items", this.state.news_items);

                formData.append("phone", this.state.phone);
                formData.append("month", month);
                formData.append("year", year);

                http.post(endpoints.ISHAAT,
                    formData, {'Content-Type': 'multipart/form-data'}
                )
                    .then(res => {
                        this.setState({
                            isSubmitting: false
                        });

                        if (res.status !== 201) {
                            const Toast = Swal.mixin({
                                toast: true,
                                position: "top-end",
                                showConfirmButton: false,
                                timer: 3000
                            });

                            Toast.fire({
                                type: "warning",
                                title: "There is an error in your submission, try again"
                            });
                            this.LoadingBar.complete();
                        } else {
                            const Toast = Swal.mixin({
                                toast: true,
                                position: "top-end",
                                showConfirmButton: false,
                                timer: 3000
                            });

                            Toast.fire({
                                type: "success",
                                title: "Ishaat report submitted successfully "
                            });
                            this.LoadingBar.complete();
                            this.setState({
                                truth: 0,
                                review: 0,
                                irfan: 0,
                                websites: 0,
                                extra_work: "",
                                periodicals: 0,
                                isSubmitting: false,
                                news_items: "",
                                attachment: null,
                                phone: ""
                            });
                            this.props.loadStatus(month, year);

                            // $('.modal').modal('show');
                        }
                    })
                    .catch(error => {
                        this.setState({
                            isSubmitting: false
                        });
                        this.LoadingBar.complete();
                        let errorMessage =
                            (typeof error === "string" && error) ||
                            "An error occured, please try again in a moment.";

                        const Toast = Swal.mixin({
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 3000
                        });

                        Toast.fire({
                            type: "error",
                            title: errorMessage
                        });
                        // alert(JSON.stringify(error));
                        console.log(errorMessage);
                    });
            }
        });
    }

    render() {
        const {year, monthName} = this.props.monthYear;
        const {data, isFetching, failed} = this.props.status;
        const {isSubmitting} = this.state;
        return (
            <div>
                {failed ? (
                    <NetworkError/>
                ) : (
                    <section className="content">
                        {this.state.loading || isFetching ? (
                            <div>
                                <div className="spinner">
                                    <Loader type="ThreeDots" color="#00BFFF" height="40" width="40"/>
                                </div>
                            </div>
                        ) : (
                            <div>
                                {!data.ishaat ? (
                                    <div>
                                        <LoadingBar onRef={ref => (this.LoadingBar = ref)}/>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="card">
                                                    <div className="card-header card-header-primary">
                                                        <h4 className="card-title">
                                                            ISHA'AT (PUBLICATIONS) - {monthName},{" "}
                                                            {year}
                                                        </h4>
                                                        <p className="card-category">Complete the form below</p>
                                                    </div>
                                                    <div className="card-body">
                                                        <form onSubmit={this.handleSubmit}>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label className="bmd-label-floating">
                                                                            No. of Khuddam subscribers of the following
                                                                            periodicals / journals in your Majlis (The
                                                                            Truth){" "}
                                                                        </label>

                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            id="truth"
                                                                            name="truth"
                                                                            value={this.state.truth}
                                                                            onChange={this.handleChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label className="bmd-label-floating">
                                                                            No. of Khuddam subscribers of the following
                                                                            periodicals / journals in your Majlis
                                                                            (Review
                                                                            of Religion){" "}
                                                                        </label>

                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            id="review"
                                                                            name="review"
                                                                            value={this.state.review}
                                                                            onChange={this.handleChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label className="bmd-label-floating">
                                                                            No. of Khuddam subscribers of the following
                                                                            periodicals / journals in your Majlis (Al
                                                                            Irfan){" "}
                                                                        </label>

                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            id="irfan"
                                                                            name="irfan"
                                                                            value={this.state.irfan}
                                                                            onChange={this.handleChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label className="bmd-label-floating">
                                                                            No. of Khuddam subscribers of the following
                                                                            periodicals / journals in your Majlis
                                                                            (Jamaat
                                                                            Websites){" "}
                                                                        </label>

                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            id="websites"
                                                                            name="websites"
                                                                            value={this.state.websites}
                                                                            onChange={this.handleChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <label className="bmd-label-floating">
                                                                            {" "}
                                                                            Any extra ordinary work in publication
                                                                            during
                                                                            the month
                                                                        </label>
                                                                        <textarea
                                                                            className="form-control"
                                                                            id="extra_work"
                                                                            name="extra_work"
                                                                            onChange={this.handleChange}
                                                                            value={this.state.extra_work}
                                                                            rows="5"
                                                                        />
                                                                    </div>
                                                                    <span className="text-danger">
                                {this.validator.message(
                                    "extra work",
                                    this.state.extra_work,
                                    "required|min:2|max:200"
                                )}
                              </span>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                {/* <div className="col-md-8">
                        <div className="form-group">
                          <label className="bmd-label-floating">If Atfal organisation is not established , state reasons thereof  and also mention what efforts have been done in this regard</label>

                            <input 
                                type="number"
                                 className="form-control"
                                 id="atfal_organization_not_established" 
                            
                                 name="atfal_organization_not_established"
                                 onChange ={this.handleChange}
                                 />
                        </div>
                      </div> */}
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label className="bmd-label-floating">
                                                                            No. of Khuddam who contributed during the
                                                                            months towards issuing Jamaat periodicals
                                                                            for
                                                                            Tabligh purpose{" "}
                                                                        </label>

                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            min="0"
                                                                            id="periodicals"
                                                                            name="periodicals"
                                                                            value={this.state.periodicals}
                                                                            onChange={this.handleChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <label className="bmd-label-floating">
                                                                            {" "}
                                                                            News item about your Qaidaat
                                                                        </label>
                                                                        <textarea
                                                                            className="form-control"
                                                                            id="news_items"
                                                                            name="news_items"
                                                                            onChange={this.handleChange}
                                                                            value={this.state.news_items}
                                                                            rows="5"
                                                                        />
                                                                    </div>
                                                                    <span className="text-danger">
                                {this.validator.message(
                                    "news item",
                                    this.state.news_items,
                                    "required|min:2|max:200"
                                )}
                              </span>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label className="bmd-label-floating">
                                                                            Nazim Ishaat's Phone Number
                                                                        </label>

                                                                        <input
                                                                            type="tel"
                                                                            className="form-control"
                                                                            id="phone"
                                                                            name="phone"
                                                                            value={this.state.phone}
                                                                            onChange={this.handleChange}
                                                                        />
                                                                    </div>
                                                                    <span className="text-danger">
                                {this.validator.message(
                                    "nazim phone number",
                                    this.state.phone,
                                    "required|min:5|max:11"
                                )}
                              </span>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-4 col-sm-4">
                                                                    <h4 className="title">
                                                                        Attachment (Copies of publications in the month)
                                                                    </h4>

                                                                    <input type="file" onChange={this.onChangeFile}/>
                                                                </div>
                                                            </div>

                                                            {isSubmitting ? <Loading/> : ""}

                                                            <button
                                                                type="submit"
                                                                className="btn btn-success pull-right"
                                                                disabled={isSubmitting}
                                                            >
                                                                {isSubmitting ? "Loading..." : "Submit"}
                                                            </button>
                                                            <div className="clearfix"/>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div/>
                                    </div>
                                ) : (
                                    <div className="d-flex align-items-center">
                                        <h2>
                                            You already submitted Ishaat report for{" "}
                                            <b>
                                                {monthName}, {year}
                                            </b>
                                        </h2>
                                    </div>
                                )}
                            </div>
                        )}
                    </section>
                )}
            </div>
        );
    }
}

Ishaat.propTypes = {
    createUser: PropTypes.func.isRequired,
    logOutUser: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    isLoggedIn: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
    user: state.person.user,
    isLoggedIn: state.person.isLoggedIn,
    monthYear: state.currentMonth.monthYear,
    status: state.status
});

export default connect(mapStateToProps, {createUser, logOutUser, loadStatus})(Ishaat);
